import { Appointment } from './appointment.model';
import { Location } from '../associates/location.model';
import { County } from '../associates/county.model';
import { TransportOption } from './transport-option.model';

export class AlternateTransportation {
  id: string = null;
  addressLine: string = null;
  appointmentId: string = null;
  contactType: string = null;
  countyId: string = null;
  embedded?: AlternateTransportationEmbed = null;
  googlePlaceId?: string = null;
  phone: string = null;
  pickUpDropOff: string = null;
  placeId: string = null;
  postalZipCode: string = null;
  sequence: string = null;
  transportOptionId: string = null;

  constructor(obj?: AlternateTransportation) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

class AlternateTransportationEmbed {
  appointment?: Appointment = null;
  county?: County = null;
  place?: Location = null;
  transportOption?: TransportOption = null;
}
